import apiClient from "../common/apiClient";

export default class UserController {
  async Create(data, token) {
    try {
      return await apiClient.post("/rolemaster", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(data, token) {
    try {
      return await apiClient.put("/rolemaster/", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async GetRoles(tenantId, token) {
    try {
      return await apiClient.get("/rolemaster/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Delete(id, token) {
    try {
      return await apiClient.delete("/rolemaster/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
